import { Injectable } from '@angular/core';
import { BaseService } from '../../../../core/base/base.service';
import { GenericRoomModel } from '../../../../core/models/generic-room.model';
import { AuthService } from '../../../../core/services/auth.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GenericRoomService extends BaseService<GenericRoomModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'generic-room', authService);
  }
}
